import { createStore } from 'vuex'
import ModuleUser from './user'
export default createStore({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user:ModuleUser,
  }
})
